<section class="bg-bg-loading absolute z-10 w-screen h-screen flex justify-center items-center px-8"
  *ngIf="mainLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</section>

<mat-sidenav-container [ngClass]="mainLoading ? 'blur-sm' : ''">
  <mat-sidenav #sidenav mode="push" class="bg-gradient-120 from-primary to-secondary">
    <mat-toolbar class="!bg-transparent my-4 flex justify-center w-full">
      <span class="text-white">Menu Principal</span>
    </mat-toolbar>

    <div *ngFor="let item of menu">
      <button mat-button class="!rounded-none !p-6 w-full !justify-start !text-white hover:bg-primary"
        *ngIf="!item.subMenus && hasRole(item.roles)" (click)="goToPage(item.route!, sidenav)">
        <mat-icon>{{ item.icon }}</mat-icon>
        {{ item.title }}
      </button>

      <mat-accordion *ngIf="item.subMenus">
        <mat-expansion-panel class="bg-transparent remove-mat-expansion-panel-padding"
          [ngClass]="{'bg-transparent': !panelOpenState, 'bg-secondary': panelOpenState}"
          (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header class="shadow-none">
            <mat-panel-title class="text-white font-light">
              <mat-icon class="mr-2">{{ item.icon }}</mat-icon>
              {{ item.title }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <button *ngFor="let subMenu of item.subMenus" (click)="goToPage(subMenu.route, sidenav)"
            class="pt-4 pb-4 pl-4 w-full text-left items-center bg-transparent text-white hover:bg-primary">
            {{ subMenu.description }}
          </button>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="">
    @if(isDevelopment) {
    <div class="dev-flag">
      <h2>Desenvolvimento</h2>
    </div>
    }

    @if(isHomolog) {
    <div class="homolog-flag">
      <h2>Homologação</h2>
    </div>
    }
    <mat-toolbar class="bg-white my-4 flex justify-between rounded-xl shadow-lg px-4 py-2">
      <div class="flex items-center">
        <button mat-icon-button aria-label="Icone do menu" matTooltip="Exibir menu" (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <img src="/assets/core/assets/images/logo-planner-azul.png" (click)="redirectDashboard()" alt="logo"
          class="ml-4 w-32" style="cursor: pointer;" />
      </div>

      <div class="flex gap-4 items-center">
        <!-- <span>Tipo usuário: {{profileData?.keycloakRoles}}</span> -->
        <span class="company" *ngIf="profileData?.company">Empresa: {{profileData?.company?.name}}
          ({{profileData?.company?.type | companyTypePipe}})</span>
        <button mat-flat-button [matMenuTriggerFor]="perfil" aria-label="Menu do perfil"
          class="!bg-gray350 !text-black333 text-sm flex items-center rounded-full px-4 py-2">
          <span class="mr-2">{{ nameUser }} ({{profileData?.keycloakRoles}})</span>
          <mat-icon class="order-last">keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #perfil="matMenu" xPosition="before">
          <button mat-menu-item (click)="goToProfile()">
            <mat-icon>person</mat-icon>
            <span>Perfil</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Sair</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>

    <router-outlet class="content"></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>